import {
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { BehaviorSubject } from "rxjs";
import { DevicePilomat } from "../model/devicePilomat";

import { AccessMethod } from "../model/accessMethod";
import { AccessMethods } from "../model/accessMethods";
import { UserService } from "../service/user.service";

import { Log } from "../util/log";
import { Output, EventEmitter } from '@angular/core';

import { Overlay } from "@angular/cdk/overlay";
import { MatDialog } from "@angular/material/dialog";
import { ControlUser } from "../model/controlUser";
import { AccessMethodsEditorComponent } from "../access-methods-editor/access-methods-editor.component";
import { StringHelper } from "../util/stringHelper";
import { AppComponent } from "../app.component";


@Component({
  selector: "app-access-methods",
  templateUrl: "./access-methods.component.html",
  styleUrls: ["./access-methods.component.css"],
})
export class AccessMethodsComponent implements OnInit {
  @Input() userOwnerId: number;
  @Input() canUserEdit;

  @Output() accessMethods = new EventEmitter<AccessMethods>();

  @ViewChild("accessmethodloader", { static: true }) loader;
  @ViewChild("accessmethodtable", { static: true }) table;

  dataSource: AccessMethodSource;
  displayedColumns: string[] = ["type", "code"];
  accessMethodList: AccessMethods;

  accessMethodTypes: Array<any> = [];

  remoteType = AccessMethod.EVENT_TYPE_REMOTE;
  remote1cType = AccessMethod.EVENT_TYPE_REMOTE1CONTROL;
  appType = AccessMethod.EVENT_TYPE_APP;
  carType = AccessMethod.EVENT_TYPE_CAR;
  phoneType = AccessMethod.EVENT_TYPE_PHONE;
  webType = AccessMethod.EVENT_TYPE_WEB;
  badgeType = AccessMethod.EVENT_TYPE_BADGE;
  pinCodeType = AccessMethod.EVENT_TYPE_PINCODE;

  constructor(
    public appComponent: AppComponent,
    private userService: UserService,
    private cdRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private overlay: Overlay
  ) {
    this.accessMethodTypes = [
      { value: AccessMethod.EVENT_TYPE_APP, text: $localize`:@@accessMethod_app:App` },
      { value: AccessMethod.EVENT_TYPE_CAR, text: $localize`:@@accessMethod_car:Targa` },
      { value: AccessMethod.EVENT_TYPE_REMOTE, text: $localize`:@@accessMethod_remote:Radiocomando JCM` },
      { value: AccessMethod.EVENT_TYPE_REMOTE1CONTROL, text: $localize`:@@accessMethod_remote1Control:Radiocomando 1Control` },
      { value: AccessMethod.EVENT_TYPE_PHONE, text: $localize`:@@accessMethod_phone:Telefono` },
      { value: AccessMethod.EVENT_TYPE_BADGE, text: $localize`:@@accessMethod_badge:Badge` },
      { value: AccessMethod.EVENT_TYPE_PINCODE, text: $localize`:@@accessMethod_pincode:Codice PIN` }
    ]
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userOwnerId']) {
      this.loadData();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.loadData();
    });
  }

  isService(): boolean {
    return this.appComponent.isService();
  }

  loadData() {
    this.loader.showLoading();

    this.dataSource = new AccessMethodSource(
      this.userOwnerId,
      this.userService,
      this.isService()
    );
    this.table.dataSource = this.dataSource;
    this.dataSource.accessMethodData.subscribe(
      (data) => {
        Log.debug("Access Methods Data: " + JSON.stringify(data));
        let accessMethodsToEmit: AccessMethods = new AccessMethods();
        accessMethodsToEmit.methods = data;
        this.accessMethods.emit(accessMethodsToEmit);
        setTimeout(() => {
          this.cdRef.detectChanges();
          Log.debug("AccessMethodsComponent:    devices loaded")
          this.loader.hideLoading();
        });
      },
      (error) => {
        this.loader.hideLoading();
        Log.debug("AccessMethodsComponent:    devices loading error")
        this.loader.showError();
      }
    );
  }


  getAccessMethodType(type: string) {
    for (let i = 0; i < this.accessMethodTypes.length; i++) {
      if (this.accessMethodTypes[i].value == type) {
        return this.accessMethodTypes[i].text;
      }
    }
  }

  modifyAccessMethods(): void {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    if (!this.dataSource.accessMethodsArray) {
      this.dataSource.accessMethodsArray.push(new AccessMethod());
    }
    const dialogRef = this.dialog.open(AccessMethodsEditorComponent, {
      width: "1000px",
      data: { accessMethodData: this.dataSource.accessMethodsArray, userOwnerId: this.userOwnerId },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {

      if (!result) {
      } else if (result) {
        this.loader.showLoading();
        Log.debug("result: ");
        Log.debug(result);

        let accessMethodsList: AccessMethods = new AccessMethods();

        accessMethodsList = result;

        this.table.dataSource.updateData(accessMethodsList, this.userOwnerId);
        this.table.renderRows();
        this.loader.hideLoading();
        this.accessMethods.emit(accessMethodsList);
      }
    });
  }
  selectIcon(type: string): string {
    if (type == this.appType) {
      return "mobile-alt";
    } else if (type == this.phoneType) {
      return "phone-alt";
    } else if (type == this.webType) {
      return "cloud";
    } else if (type == this.pinCodeType) {
      return "calculator";
    } else if (type == this.badgeType) {
      return "id-badge";
    }
    return "car"
  }
}

export class AccessMethodSource extends MatTableDataSource<AccessMethod> {
  isLoading = new BehaviorSubject(false);
  accessMethodData = new BehaviorSubject<AccessMethod[]>([]);

  accessMethodsArray: AccessMethod[] = [];

  constructor(
    private userOwnerId: number,
    private userService: UserService,
    private isService: boolean
  ) {
    super();
  }

  loadData() {
    this.accessMethodsArray = [];

    this.isLoading.next(true);
    const obs = this.userService.getUserAccessMethods(this.userOwnerId);
    obs.subscribe((data) => {
      Log.debug("Data: ");
      Log.debug(data);

      if (this.isService) {
        for (let i = 0; i < data.length; i++) {
          Log.debug("data[i]")
          Log.debug("data[i].code")
          data[i].code = StringHelper.censorString(data[i].code);
          Log.debug("data[i].code")
        }
      }

      this.accessMethodsArray = data;
      this.isLoading.next(false);
      this.accessMethodData.next(data);
    });
  }

  updateData(accessMethodList: AccessMethods, user: ControlUser) {
    Log.debug("updateData: ");
    Log.debug(accessMethodList);
    Log.debug(accessMethodList.methods[0]);

    this.accessMethodsArray = accessMethodList.methods;
    this.isLoading.next(false);
    this.accessMethodData.next(accessMethodList.methods);
  }

  connect(): BehaviorSubject<AccessMethod[]> {
    this.loadData();
    return this.accessMethodData;
  }

  disconnect() { }
}
